import {calculateTotal, calculateQuantity} from '../helpers/productHelper';

const flexFilter = (type) => (tickets) => tickets.filter(ticket => ticket.schedule === type);
const weekdaysFilter = flexFilter('LAV');
const weekFilter = flexFilter('ALL');

export const productGetters = {
    products(state) {
        return state.products;
    },

    todayProducts(state) {
        return state.todayProducts;
    },

    flexTickets(state) {
        if (state.weekdaysOnly) {
            return weekdaysFilter(state.flexTickets);
        }
        return weekFilter(state.flexTickets);
    },

    maxTicketHeight(state) {
        return Math.max(...state.ticketHeights);
    }
};

export const cartGetters = {
    total(state) {
        return calculateTotal(state.cart);
    },

    count(state) {
        return calculateQuantity(state.cart);
    },

    cart(state) {
        return state.cart;
    },

    currentTicket(state) {
        return state.ticket;
    }
};

export const passescartGetters = {
    passes_total(state) {
        return calculateTotal(state.passescart);
    },

    passes_count(state) {
        return calculateQuantity(state.passescart);
    },

    passes_cart(state) {
        return state.passescart;
    }
};

export const flexGetters = {
    isWeekDaysOnly(state) {
        return state.weekdaysOnly;
    }
};

export const fixGetters = {
    events(state) {
        return state.events;
    },

    selectedFixEvent(state) {
        return state.selectedFixEvent;
    }
};

export const stockDateGetters = {
    stockDate(state) {
        return state.stockDate;
    }
}


// WEBPACK FOOTER //
// ./src/store/getters.js